import React, {Component} from 'react';
import {NavItem, NavLink} from "reactstrap";
import {MdExitToApp} from "react-icons/md";
import {connect} from 'react-redux';
import axios from 'axios';
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";

class LoginAsAdminComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isButton: false
        }
    }


    loginAsAdmin = async () => {
        if (this.props.isMenuAdmin) {
            let user = this.props.user;
            user.role = 'admin';

            let itemUser = {
                user: user,
                menu: 'cloudzoneAdmin-admin-menuAdmin',
                sessionRole: 'cloudzoneAdmin-admin-admin',
                credit: this.props.credit,
            }
            await this.props.saveUser(itemUser);
            await this.props.updatePageAdmin({ isMenuAdmin: false });

            await this.props.redirectAdmin();
        }
        else {
            if (this.props.sessionAdmin && this.props.userAdminId) {
                this.setState({
                    isButton: true
                })

                let dataAuth = {
                    username: process.env.REACT_APP_CLIENT_ID,
                    password: process.env.REACT_APP_CLIENT_PASSWD,
                    token: process.env.REACT_APP_KEY,
                };

                let form = {
                    userId: this.props.userAdminId,
                };

                axios.put(process.env.REACT_APP_API_URL + '/api/home/loginAsAdmin', form,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': this.props.token,
                            'dataAgency': JSON.stringify(dataAuth)
                        }
                    }
                )
                    .then(async (ref) => {
                        if (ref.data.error === 0) {
                            this.setState({
                                isButton: false
                            })
                            let itemLogin = {
                                token: ref.data.token
                            }
                            await this.props.login(itemLogin);

                            let itemUser = {
                                user: ref.data.user,
                                menu: 'cloudzoneAdmin-admin-menuAdmin',
                                sessionRole: 'cloudzoneAdmin-admin-admin',
                                credit: ref.data.credit,
                            }
                            await this.props.saveUser(itemUser);

                            await this.props.redirectAdmin();
                        } else {
                            if (ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997) {
                                this.props.logOut();
                            } else {
                                alert(ref.data.message);
                                this.setState({
                                    isButton: false
                                })
                            }
                        }
                        // console.log(this.state.perPage);
                    })
                    .catch((error) => {
                        console.log(error)
                        alert("Đăng nhập admin lỗi");
                        this.setState({
                            isButton: false
                        })
                    })

            } else {
                alert("Tài khoản không tồn tại");
            }
        }
    }

    render() {
        return (
            <NavItem className="d-inline-flex" >
                <OverlayTrigger
                    delay={{ hide: 450, show: 300 }}
                    overlay={(props) => (
                        <Tooltip {...props}>
                            Đăng nhập lại Admin
                        </Tooltip>
                    )}
                    placement="bottom"
                >
                    <NavLink className="position-relative nav-link"  onClick={ () => this.loginAsAdmin() } disabled={ this.state.isButton }>
                        <MdExitToApp className="text-secondary can-click" size={20} />
                    </NavLink>
                </OverlayTrigger>
            </NavItem>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        user: state.user.user,
        credit: state.user.credit,
        sessionAdmin: state.infoAdmin.isAdmin,
        userAdminId: state.infoAdmin.userId,
        isMenuAdmin: state.infoAdmin.isMenuAdmin,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'LoginAsAdmin' }))
        },
        updateNotification: (item) => {
            dispatch(({type: 'updateNotification', item}))
        },
        login: (item) => {
            dispatch(({ type : 'login', item }))
        },
        saveUser: (item) => {
            dispatch(({ type : 'saveUser', item }))
        },
        updateCredit: (item) => {
            dispatch(({ type : 'updateCredit', item }))
        },
        updateInfoAdmin: (item) => {
            dispatch(({ type : 'updateInfoAdmin', item }))
        },
        updatePage: (item) => {
            dispatch(({ type : 'updatePage', item }))
        },
        updatePageAdmin: (item) => {
            dispatch(({ type : 'updatePageAdmin', item }))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginAsAdminComponent);